<template>
<div>
    <div id="pie1" style="width:100%;height:250px;"></div>
</div>
</template>

<script>
// import Spin from 'iview/src/component/spin.vue'
import echarts from 'echarts/lib/echarts.js'
import 'echarts/lib/chart/pie'
// import 'echarts/lib/chart/line'
// import 'echarts/lib/component/title'
// import 'echarts/lib/component/labelLine'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/dataZoom'
import 'echarts/lib/component/axisPointer'

export default {
    name: 'pieChartInnewRegisSexNum1',
    props: ['dataInfo'],
    computed: {
        echartsData() {
            try {
                const Vm = this
                let Axis1 = {}
                let Axis2 = {}
                Axis1 = Vm.dataInfo.downCount
                Axis2 = Vm.dataInfo.upCount
                let temp = [
                    {
                        value: Axis1,
                        name: '已下架'
                    },
                    {
                        value: Axis2,
                        name: '已上架'
                    },
                ]
                return temp
            } catch (Error) {
                console.log(Error)
                return []
            }
        }
    },
    data() {
        
        return {
            mycharts: null
        }
    },
    watch: {
        echartsData() {
            const Vm = this
            Vm.initEcharts()
        },
    },
    mounted() {
        let Vm = this
        Vm.myCharts = echarts.init(document.getElementById('pie1'))
        Vm.initEcharts()
        window.onresize = () => {
            Vm.myCharts.resize()
        }
    },
    methods: {
        initEcharts() {
            const Vm = this
            try {
                Vm.myCharts.setOption({
                    legend: {
                        top: 0,
                        data: ['已上架', '已下架']
                    },
                    color: ['#33CC99', '#3296FA'],
                    tooltip: {
                        show: true,
                        trigger: 'item',
                        axisPointer: {
                            type: 'shadow',
                        },
                    },
                    // grid: {
                    //     left: '3%',
                    //     right: '3%',
                    //     bottom: '30%',
                    //     top: '10%',
                    //     containLabel: true,
                    // },
                    series: [
                        {
                            type: 'pie',
                            radius: ['50%', '70%'],
                            data: Vm.echartsData,
                            avoidLabelOverlap: true,
                            label: {
                                normal: {
                                    show: true,
                                    position: 'outside'
                                },
                                emphasis: {
                                    show: true,
                                    textStyle: {
                                        fontSize: '20',
                                        fontWeight: 'bold'
                                    }
                                },
                            },
                            labelLine: {
                                normal: {
                                    show: true,
                                    lineStyle: {
                                        color: 'rgba(0, 0, 0, 0.5)'
                                    },
                                    smooth: 0.2,
                                },
                            },
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        },
                    ]
                })
            } catch (Error) {
                console.log(Error)
                return
            }
        }
    }
}
</script>

<style>
  
</style>
